import * as ActionType from '../../constants/actionType';
import {WizardFlag} from '../../constants/SetupWizardEnum';

export const setCurrentWizardView = (currentWizardView) => ({
  type: ActionType.WIZARD_SET_CURRENT_WIZARD_VIEW,
  currentWizardView,
});

export const incrementCurrentWizardView = () => ({
  type: ActionType.WIZARD_INCREMENT_CURRENT_WIZARD_VIEW,
});

export const decrementCurrentWizardView = () => ({
  type: ActionType.WIZARD_DECREMENT_CURRENT_WIZARD_VIEW,
});

export const setProcessedStep = (processedStep) => ({
  type: ActionType.SET_PROCESSED_STEP,
  processedStep,
});

export const incrementProcessedStep = () => ({
  type: ActionType.INCREMENT_PROCESSED_STEP,
});

export const decrementProcessedStep = () => ({
  type: ActionType.DECREMENT_PROCESSED_STEP,
});

export const setWizardViewData = (wizardViewData) => ({
  type: ActionType.SET_WIZARD_VIEW_DATA,
  wizardViewData,
});

export const setStepData = (stepNumber, data) => ({
  type: ActionType.SET_WIZARD_STEP_DATA,
  stepNumber,
  data,
});

export const setWizardStatus = (wizardStatus) => ({
  type: ActionType.SET_WIZARD_STATUS,
  wizardStatus,
});

export const setWizardFlag = (wizardFlag) => ({
  type: ActionType.SET_WIZARD_FLAG,
  wizardFlag,
});

export const setWizardAllowedNext = (isWizardNextAllowed) => ({
  type: ActionType.SET_IS_WIZARD_ALLOWED_NEXT,
  isWizardNextAllowed,
});

export const resetWizardState = () => ({
  type: ActionType.STATE_WIZARD_RESET,
});

export const restoreWizardState = (state) => ({
  type: ActionType.RESTORE_WIZARD_STATE,
  state,
});

export const setCurrentStepData = (data) => (dispatch, getState) => {
  const {wizardState} = getState();
  const {currentWizardView} = wizardState;

  return dispatch(setStepData(currentWizardView, data));
};

export const clearWizardFlag = () => ({
  type: ActionType.SET_WIZARD_FLAG,
  wizardFlag: WizardFlag.NONE,
});

export const setStepName = (stepName) => ({type: ActionType.SET_WIZARD_STEP_NAME, stepName});

export const setWizardInitialTrayType = (initialTrayType) => ({
  type: ActionType.SET_WIZARD_INITIAL_TRAY_TYPE,
  initialTrayType,
});

export const setAutoA1OffsetCalibrationProgress = (progressPercentage) => ({
  type: ActionType.SET_AUTO_A1_OFFSET_CALLIBRATION_PROGRESS,
  progressPercentage,
});
